import React, { useEffect, useState } from 'react';
import './WelcomeMessage.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const categories = [
  'general', 'technology', 'finance', 'health', 'sports', 'fashion', 'weather', 'world', 'entertainment'
];

const WelcomeMessage = () => {
  const [trendingTopics, setTrendingTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('general');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTrendingTopics = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`/trending?category=${selectedCategory}`);
        console.log('Trending topics fetched:', response.data.choices[0].message.content);
        // Extract topics and descriptions using regex with \n as row separator
        const content = response.data.choices[0].message.content;
        const topicRegex = /"topic":\s*"([^"]+)"/g;
        const descRegex = /"description":\s*"([^"]+)"/g;

        let topics = [];
        let topicMatch, descMatch;
        let id = 1;

        while ((topicMatch = topicRegex.exec(content)) && (descMatch = descRegex.exec(content))) {
          topics.push({
            id: id++,
            topic: topicMatch[1],
            description: descMatch[1]
          });
        }

        if (topics.length === 0) {
          setError('No topics found in response.');
        }
        setTrendingTopics(topics);
      } catch (error) {
        setError(error);
        setTrendingTopics([]);
      }
      setLoading(false);
    };

    fetchTrendingTopics();
  }, [selectedCategory]);

  return (
    <div className="container bg-white text-center">
      <br />
      <section className="d-flex justify-content-between align-items-center pt-3">
        <h4>DebateCast</h4>
        <p className="fst-italic text-muted text-success fs-5" style={{ fontFamily: 'serif', fontSize: '1.1rem' }}>
          Pick a side. Start a debate.
        </p>
      </section>

      <hr />

      <section>
        <h5 className='text-start mb-3'>Trending Topics</h5>
        <ul className="nav nav-tabs">
          {categories.map(category => (
            <li className="nav-item" key={category}>
              <a
                href='#'
                className={`nav-link ${selectedCategory === category ? 'active' : ''} text-success`}
                onClick={() => setSelectedCategory(category)}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </a>
            </li>
          ))}
        </ul>
        <ul className="list-unstyled" style={{ height: '65vh', overflowY: 'scroll' }}>
          {loading && <li>Loading...</li>}
          {error && <li>Error loading topics.</li>}
          {!loading && !error && trendingTopics.length === 0 && (
            <li>No trending topics found.</li>
          )}
          {!loading && !error && trendingTopics.map(item => (
            <li key={item.id} className="text-start border p-3 mb-3 rounded">
              <h5>{item.topic}</h5>
              <div className='d-flex justify-content-between align-items-center'>
                <p className='col-7'>{item.description}</p>
                <button
                  className="btn btn-success py-0"
                  onClick={() => navigate('/dig-deeper', { state: { topic: item.topic } })}
                >
                  Dig Deeper
                </button>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default WelcomeMessage;
